import item from './item';
import list from './list';
export default {
  namespaced: true,
  modules: {
    list,
    item
  },
  mutations: {},
  actions: {}
};
